import { HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './price.module.css';

type PriceProps = HTMLAttributes<HTMLSpanElement> & {
	old?: boolean;
	discount?: boolean;
	stockAvailable?: boolean;
};

export const Price = ({ old, discount, stockAvailable, className, ...rest }: PriceProps) => (
	<span
		className={clsx(
			styles.root,
			{
				[styles.old]: old,
				[styles.discount]: discount,
				[styles.noStockAvailable]: !stockAvailable,
			},
			className,
		)}
		{...rest}
	/>
);
